import { IDeleteProjetoInformacoesUseCase } from "../../../presentation/useCases/delete/delete_projeto_informacoes_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

export class DeleteProjetoInformacoesUseCase implements IDeleteProjetoInformacoesUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async deleteProjetoInformacoes(IdInformacoes: number): Promise<void> {
    await this.repository.deleteProjetoInformacoes(IdInformacoes);
  }
}
